import { GeneralTranslation } from "@swo/storefront";
import React from "react";
import { HeaderPinnedState } from "../../components/HeaderComponent/subcomponents/use-header-pinned-state";
import { Translated } from "../../domain/translations/translations";
import { PDPState } from "./PDP_SingleImageCarousel/availability/use-product-variant-state";
import { PDPBelowTheFoldLayout_SpareParts } from "./PDPBelowTheFoldLayout_SpareParts";
import { PDPMainComponentProps } from "./PDPMainComponent";
import { ReviewTranslations } from "./reviewTranslations";
import { PDPBelowTheFoldLayout_Product } from "./PDPBelowTheFoldLayout_Product";

export const PDPBelowTheFoldLayout: React.FC<{
  pdpState: PDPState;
  data: PDPMainComponentProps["data"];
  gt: Translated<GeneralTranslation>;
  reviewsT: ReviewTranslations;
  primaryButton: React.JSX.Element;
  headerState: HeaderPinnedState;
  children: React.ReactNode;
}> = ({ pdpState, data, gt, reviewsT, primaryButton, headerState, children }) => {
  const pdpSubtype: "product" | "spare-part" = data.selectedProduct.isSparePart ? "spare-part" : "product";

  switch (pdpSubtype) {
    case "product": {
      return (
        <PDPBelowTheFoldLayout_Product
          data={data}
          gt={gt}
          reviewsT={reviewsT}
          headerState={headerState}
          pdpState={pdpState}
          primaryButton={primaryButton}
        >
          {children}
        </PDPBelowTheFoldLayout_Product>
      );
    }
    case "spare-part": {
      return <PDPBelowTheFoldLayout_SpareParts data={data}>{children}</PDPBelowTheFoldLayout_SpareParts>;
    }
    default: {
      const _: never = pdpSubtype;
      return _;
    }
  }
};
